/** Creators Store **/

import { defineStore } from 'pinia';

import msApi from '@/utils/msApi';
import { cloneDeep } from 'lodash';
import { useCampaignStore } from '@/store/campaign';

type BriefHashtag = {
  platform: string;
  hashtags: string[];
};

type BriefHandle = {
  platform: string;
  handles: string[];
};

export type BriefForm = {
  brief_name: string;
  brand_id: string;
  start_date: '';
  end_date: '';
  platform: string | string[];
  niche: string[];
  overview: string;
  objectives: string;
  call_to_action: string;
  content_creation_steps: string[];
  key_selling_points: string[];
  handle: BriefHandle[];
  hashtag: BriefHashtag[];
  handles?: string[];
  hashtags?: string[];
  brief_id?: string | null | undefined;
  thumbnail?: any[];
  assets?: any[];
  pre_approval?: boolean;
  advertiser_pre_approval?: boolean;
};

export const emptyForm: BriefForm = {
  brief_name: '',
  brand_id: '',
  platform: '',
  niche: [],
  start_date: '',
  end_date: '',
  overview: '',
  objectives: '',
  call_to_action: '',
  content_creation_steps: ['', ''],
  key_selling_points: ['', ''],
  handle: [],
  hashtag: [],
  thumbnail: [] as any[],
  assets: [] as any[],
  pre_approval: false,
  advertiser_pre_approval: false,
};

export const useBriefsStore = defineStore('briefs', {
  state: () => ({
    briefsList: [] as any[],
    briefsForm: { ...emptyForm },
    selectedBrief: { ...emptyForm },
    createBriefLoading: false,
    getBriefLoading: false,
    error: null as any,
    previewBriefId: '' as string | null,
    briefError: false as boolean,
  }),
  actions: {
    async doCreateCampaignBrief(form: any) {
      this.error = null;
      try {
        const brief = await msApi.msPost('/briefs/brief', form);
        this.briefsForm = emptyForm;
        return brief;
      } catch (e) {
        this.error = e;
        throw e;
      }
    },
    resetBriefForm() {
      this.briefsForm = cloneDeep(emptyForm);
      this.briefsForm.content_creation_steps = ['', ''];
      this.briefsForm.key_selling_points = ['', ''];
      this.briefsForm.handle = [];
      this.briefsForm.hashtag = [];
      useCampaignStore().campaignForm.contract_ids = [];
    },
    async doGetCampaignBrief(brand_id: string) {
      this.error = null;
      this.getBriefLoading = true;
      try {
        const briefs = await msApi.msPost('/briefs/get_briefs', {
          brand_id: brand_id,
        });
        this.briefsList = briefs.data;
        this.getBriefLoading = false;
        return briefs;
      } catch (e) {
        this.error = e;
        this.getBriefLoading = false;
        throw e;
      }
    },
    async doEditCampaignBrief(form: any) {
      this.error = null;
      try {
        const brief = await msApi.msPost('/briefs/update_brief', form);
        this.briefsForm = emptyForm;
        return brief;
      } catch (e) {
        this.error = e;
        throw e;
      }
    },
    async doDeleteCampaignBrief(brief_Id: string) {
      this.error = null;
      try {
        const brief = await msApi.msPost('/briefs/delete_brief', {
          brief_id: brief_Id,
        });
        return brief;
      } catch (e) {
        this.error = e;
        throw e;
      }
    },
  },
});
